import { render, staticRenderFns } from "./excel-import.vue?vue&type=template&id=20903c34&scoped=true&"
import script from "./excel-import.vue?vue&type=script&lang=js&"
export * from "./excel-import.vue?vue&type=script&lang=js&"
import style0 from "./excel-import.vue?vue&type=style&index=0&id=20903c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20903c34",
  null
  
)

export default component.exports